import { render, staticRenderFns } from "./ITwinBimCompare.vue?vue&type=template&id=1eefb0eb&scoped=true"
import script from "./ITwinBimCompare.vue?vue&type=script&lang=js"
export * from "./ITwinBimCompare.vue?vue&type=script&lang=js"
import style0 from "./ITwinBimCompare.vue?vue&type=style&index=0&id=1eefb0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eefb0eb",
  null
  
)

export default component.exports